module.exports = __webpack_public_path__ + "img/13.35d9b5ca.png";